import { Component, Inject, OnInit } from "@angular/core";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";

@Component({
	selector: "app-dismiss-dialog",
	templateUrl: "./dismiss-dialog.component.html",
	styleUrls: ["./dismiss-dialog.component.scss"],
})
export class DismissDialogComponent implements OnInit {
	title: string;
	content: string;
	constructor(@Inject(MAT_DIALOG_DATA) public data) {
		this.title = data.title;
		this.content = data.content;
	}

	ngOnInit(): void {}
}
